import { HttpParams } from '@angular/common/http'

export class LoadingHttpParams extends HttpParams {
    constructor(public isBackground: boolean) {
        super()
    }
}
